export default {
  EN:{
  Halal: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt0060f0d7f6b703f5/607652717ec0d95ee902f4d5/HALAL.png?quality=50&width=45&format=webp",
    newTab: "FALSE",
    position: "1",
    productID: "Halal",
    productTile: "Halal",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Asian: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltc9d0c1e4522cd88a/6076528f1de09d61579f66b0/Asian.png?quality=50&width=45&format=webp",
    newTab: "FALSE",
    position: "1",
    productID: "Asian",
    productTile: "Asian",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Healthy: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt71e284cf6a7b3b48/6076529bb1aadc4a2ab2586c/Healthy.png?quality=50&width=45&format=webp",
    newTab: "FALSE",
    position: "1",
    productID: "Healthy",
    productTile: "Healthy",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Western: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt6be5bd26c01dca37/607652bd93a327076df3a4b2/Western.png?quality=50&width=45&format=webp",
    newTab: "TRUE",
    position: "2",
    productID: "Western",
    productTile: "Western",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Vegetarian: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltdf517afb515e952d/609ba31c460f0f28dcd7386c/vegetarianpng_1620812571777.png?quality=50&width=45&format=webp",
    newTab: "TRUE",
    position: "2",
    productID: "Vegetarian",
    productTile: "Vegetarian",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Dessert: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blta60bfef6553cb218/607652affb66d367c151ac1d/Dessert.png?quality=50&width=45&format=webp",
    newTab: "TRUE",
    position: "2",
    productID: "Dessert",
    productTile: "Dessert",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Beverages: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt27ad4cf08de222d8/607652c7f43cbb6d4a0f8cbe/Beverages.png?quality=50&width=45&format=webp",
    newTab: "TRUE",
    position: "2",
    productID: "Beverages",
    productTile: "Beverages",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
},
  TH:{
    Halal: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt0060f0d7f6b703f5/607652717ec0d95ee902f4d5/HALAL.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Halal",
      productTile: "ฮาลาล",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Asian: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltc9d0c1e4522cd88a/6076528f1de09d61579f66b0/Asian.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Asian",
      productTile: "อาหารอาเซียน",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Healthy: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt71e284cf6a7b3b48/6076529bb1aadc4a2ab2586c/Healthy.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Healthy",
      productTile: "อาหารเพื่อสุขภาพ",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Western: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt6be5bd26c01dca37/607652bd93a327076df3a4b2/Western.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Western",
      productTile: "อาหารตะวันตก",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Vegetarian: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltdf517afb515e952d/609ba31c460f0f28dcd7386c/vegetarianpng_1620812571777.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Vegetarian",
      productTile: "มังสวิรัติ",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Dessert: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blta60bfef6553cb218/607652affb66d367c151ac1d/Dessert.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Dessert",
      productTile: "อาหารว่าง",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Beverages: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt27ad4cf08de222d8/607652c7f43cbb6d4a0f8cbe/Beverages.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Beverages",
      productTile: "เครื่องดื่ม",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
  },
  ID:{
    Halal: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt0060f0d7f6b703f5/607652717ec0d95ee902f4d5/HALAL.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Halal",
      productTile: "Makanan Halal",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Asian: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltc9d0c1e4522cd88a/6076528f1de09d61579f66b0/Asian.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Asian",
      productTile: "Makanan Asia",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Healthy: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt71e284cf6a7b3b48/6076529bb1aadc4a2ab2586c/Healthy.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Healthy",
      productTile: "Makanan Sehat",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Western: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt6be5bd26c01dca37/607652bd93a327076df3a4b2/Western.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Western",
      productTile: "Makanan Barat",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Vegetarian: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltdf517afb515e952d/609ba31c460f0f28dcd7386c/vegetarianpng_1620812571777.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Vegetarian",
      productTile: "Vegetarian",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Dessert: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blta60bfef6553cb218/607652affb66d367c151ac1d/Dessert.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Dessert",
      productTile: "Dessert",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Beverages: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt27ad4cf08de222d8/607652c7f43cbb6d4a0f8cbe/Beverages.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Beverages",
      productTile: "Minuman",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
  },
}
